import PropTypes from 'prop-types';
import React from 'react';
import TranslationUtils from 'Utils/TranslationUtils';
import { Helmet } from 'react-helmet';
import PiplLogo from '../../Assets/pipl.svg';
import styles from './InvalidTokenPage.module.less';

const InvalidTokenPage = ({ invalidReason = 'expired' }) => {
  const headerText = TranslationUtils.getText('Oops... ');
  let bodyText = '';
  if (invalidReason === 'expired') {
    bodyText = TranslationUtils.getText('This link has expired. Please request a new one and try again.');
  } else if (invalidReason === 'used') {
    bodyText = TranslationUtils.getText('This link has already been used.');
  } else {
    bodyText = TranslationUtils.getText('This link is no longer valid.');
  }

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{gettext('Oops...')}</title>
      </Helmet>
      <a href="https://pipl.com">
        <img src={PiplLogo} alt="" width="80" height="49" />
      </a>
      <div className={styles.content}>
        <span test-id="page-title" className={styles.title}>
          {headerText}
        </span>

        <div className={styles.reason}>
          <span>{bodyText}</span>
        </div>
      </div>
      <span className={styles.body}>
        {TranslationUtils.getText('Please')}
        <a href="mailto:support@pipl.com" className={styles.footerLink}>
          <span>{TranslationUtils.getText('contact support ')}</span>
        </a>
        {TranslationUtils.getText('for further assistance')}
      </span>
      <div className={styles.footer}>
        <a className={styles.footerLink} href="https://pipl.com/">
          <span>{TranslationUtils.getText('EMAIL_CONFIRM_PAGE_FOOTER')}</span>
        </a>
      </div>
    </div>
  );
};

InvalidTokenPage.propTypes = {
  invalidReason: PropTypes.string,
};

export default InvalidTokenPage;
